import { Modal } from '@sgcmpteltd/uikit-next';
import { Menu, MenuItem } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';

import { joinSgcmSite } from '@/utils/url/join/public';

import { MODAL_TRANSITION_DURATION_MS_DEFAULT, TEXT_MONTHS } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PriceListModal: Component = ({
  dealerId,
  priceList,
  isOpen,
  transitionDurationMs = MODAL_TRANSITION_DURATION_MS_DEFAULT,
  onClose,
}) => {
  if (!priceList) {
    return (
      <Modal
        className={styles.containerRoot}
        contentClassName={styles.containerModalContent}
        isOpen={isOpen}
        title=""
        transitionDurationMs={transitionDurationMs}
        isBackdropStatic
        onClose={onClose} />
    );
  }

  function generateFormatedDate(date: string): string {
    const [year, month, day] = date.split('-');
    const formattedDate = `${day} ${TEXT_MONTHS[parseInt(month, 10) - 1]} ${year}`;
    return formattedDate;
  }

  return (
    <Modal
      className={styles.containerRoot}
      contentClassName={styles.containerModalContent}
      headerClassName={styles.containerHeader}
      isOpen={isOpen}
      title="Download Pricelist"
      titleContainerClassName={styles.containerTitle}
      transitionDurationMs={transitionDurationMs}
      onClose={onClose}>
      <Menu className={cx(
        styles.menuRoot,
        styles.isBorderless,
      )}>
        {priceList.toReversed().map((priceDate, index) => {
          const pdfHref = `${joinSgcmSite(`/new_cars/pricelist/${dealerId}/${priceDate}.pdf`)}`;
          const isLatest = index === 0;
          const formattedDate = `${isLatest ? 'Latest, ' : ''}${generateFormatedDate(priceDate)}`;
          return (
            <MenuItem
              key={priceDate}
              contentClassName={styles.textMenuItem}
              onClick={() => {
                window.open(
                  `${pdfHref}`,
                  '_blank',
                  'noreferrer noopener',
                );
              }}>
              {formattedDate}
            </MenuItem>
          );
        })}
      </Menu>
    </Modal>
  );
};
